import { FloatingButtonUser } from '@fb/models';

export function parseFloatingButtonUser(
  user: FloatingButtonUser | string | null | undefined,
): FloatingButtonUser | null {
  if (user == null || user === '') {
    return null;
  }

  if (typeof user === 'string') {
    try {
      return JSON.parse(user) as FloatingButtonUser;
    } catch {
      return null;
    }
  }

  return user;
}
